import { addDays, differenceInCalendarDays, format, isValid, parseISO } from "date-fns";
import { CONSECRATION_FEASTS } from "@/data/consecrationFeasts";

export const civilDate = (value) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parsed = parseISO(value);
  return isValid(parsed) && format(parsed, "yyyy-MM-dd") === value ? parsed : null;
};
export const dateKey = (date) => format(date, "yyyy-MM-dd");
export const displayDate = (value, pattern = "d MMMM yyyy") => {
  const date = civilDate(value);
  return date ? format(date, pattern) : "";
};
export const planFromStart = (startDate, details = {}) => {
  const start = civilDate(startDate);
  if (!start || start.getFullYear() < 1900 || start.getFullYear() > 2099) return null;
  return { ...details, startDate, endDate: dateKey(addDays(start, 33)) };
};
export const planFromFeast = (feast, year) => feast && civilDate(feast.date)
  ? planFromStart(dateKey(addDays(civilDate(feast.date), -33)), { mode: "feast", feastKey: feast.key, feastName: feast.name, year })
  : null;
export const scheduledDate = (startDate, day) => {
  const start = civilDate(startDate);
  return start && Number.isInteger(day) && day >= 1 && day <= 34 ? dateKey(addDays(start, day - 1)) : null;
};
export const planDay = (startDate, today) => {
  const start = civilDate(startDate);
  return start ? differenceInCalendarDays(today, start) + 1 : null;
};
export const feastChoices = (records, year) => CONSECRATION_FEASTS.flatMap((feast) => {
  const event = records.find((item) => item.id === `roman-of-${year}-${feast.key}`);
  return event && civilDate(event.date) ? [{ ...feast, date: event.date, transferred: event.date.slice(5) !== feast.usual }] : [];
}).sort((a, b) => a.date.localeCompare(b.date));